"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderInput = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _ArrowBackIosRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackIosRounded"));
var _ArrowForwardIosRounded = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIosRounded"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
var _useReactMoment = require("../../hooks/useReactMoment");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  getDateFormat,
  getFromDay,
  getFrom7Day,
  getFromMonth,
  getFromYear,
  getToDay,
  getTo7Day,
  getToMonth,
  getToYear,
  isSameCurrentDateByDay
} = _paulCorePackage.functions;
const RenderInput = exports.RenderInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, inputRef) => {
  let {
    inputProps,
    InputProps,
    setFromDay,
    setToDay,
    setDate,
    toDay,
    fromDay,
    minDate,
    openTo
  } = _ref;
  const {
    reactMoment
  } = (0, _useReactMoment.useReactMoment)();
  const [disabledNext, setDisabledNext] = (0, _react.useState)(false);
  const [disabledPrev, setDisabledPrev] = (0, _react.useState)(false);
  const nextStep = (0, _react.useCallback)(_ref2 => {
    let {
      ifRule,
      to,
      fFalse
    } = _ref2;
    if (ifRule) {
      setFromDay(reactMoment(minDate));
      setToDay(to);
      setDate(to);
      setDisabledPrev(true);
    } else {
      setFromDay(fFalse);
      setToDay(fromDay);
      setDate(fromDay);
      setDisabledNext(false);
    }
  }, [fromDay, minDate, setDate, setFromDay, setToDay, reactMoment]);
  const prevStep = (0, _react.useCallback)(_ref3 => {
    let {
      ifRule,
      from,
      tFalse
    } = _ref3;
    if (ifRule) {
      setFromDay(from);
      setToDay(reactMoment());
      setDisabledNext(true);
    } else {
      setFromDay(toDay);
      setToDay(tFalse);
      setDate(tFalse);
      setDisabledPrev(false);
    }
  }, [setDate, setFromDay, setToDay, toDay, reactMoment]);
  const nextDate = (0, _react.useCallback)(() => {
    switch (openTo) {
      case 'hour':
        prevStep({
          ifRule: getToDay(toDay).isAfter(reactMoment(), 'day'),
          from: getFromDay(),
          tFalse: getToDay(toDay)
        });
        break;
      case 'day':
        prevStep({
          ifRule: getToDay(toDay).isAfter(reactMoment(), 'day'),
          from: getFromDay(),
          tFalse: getToDay(toDay)
        });
        break;
      case 'week':
        prevStep({
          ifRule: getTo7Day(toDay).isAfter(reactMoment(), 'day'),
          from: getFrom7Day(),
          tFalse: getTo7Day(toDay)
        });
        break;
      case 'month':
        prevStep({
          ifRule: getToMonth(toDay).isAfter(reactMoment(), 'day'),
          from: getFromMonth(),
          tFalse: getToMonth(toDay)
        });
        break;
      case 'year':
        prevStep({
          ifRule: getToYear(toDay).isAfter(reactMoment(), 'day'),
          from: getFromYear(),
          tFalse: getToYear(toDay)
        });
        break;
      default:
        break;
    }
  }, [toDay, openTo, prevStep, reactMoment]);
  const prevDate = (0, _react.useCallback)(() => {
    switch (openTo) {
      case 'hour':
        nextStep({
          ifRule: getFromDay(toDay).isBefore(reactMoment(minDate), 'day'),
          to: getToDay(minDate),
          fFalse: getFromDay(fromDay)
        });
        break;
      case 'day':
        nextStep({
          ifRule: getFromDay(toDay).isBefore(reactMoment(minDate), 'day'),
          to: getToDay(minDate),
          fFalse: getFromDay(fromDay)
        });
        break;
      case 'week':
        if (getFrom7Day(toDay).isAfter(reactMoment(minDate)) && reactMoment(fromDay).isoWeekday() !== 1) {
          setFromDay(getFrom7Day(reactMoment(fromDay).weekday(1)));
          setToDay(getFrom7Day(reactMoment(fromDay).weekday(7)));
          setDisabledPrev(true);
        } else nextStep({
          ifRule: getFrom7Day(toDay).isBefore(reactMoment(minDate), 'day'),
          to: getTo7Day(minDate),
          fFalse: getFrom7Day(fromDay)
        });
        break;
      case 'month':
        nextStep({
          ifRule: getFromMonth(toDay).isBefore(reactMoment(minDate), 'day'),
          to: getToMonth(minDate),
          fFalse: getFromMonth(fromDay)
        });
        break;
      case 'year':
        nextStep({
          ifRule: getFromYear(toDay).isBefore(reactMoment(minDate), 'day'),
          to: getToYear(minDate),
          fFalse: getFromYear(fromDay)
        });
        break;
      default:
        break;
    }
  }, [fromDay, minDate, nextStep, openTo, setFromDay, setToDay, toDay, reactMoment]);
  const momentLocale = reactMoment.locale();
  const getButtonDate = (0, _react.useMemo)(() => {
    if (!fromDay || !toDay || !momentLocale) return getDateFormat();
    switch (openTo) {
      case _constants.constDateType.hour:
        return getDateFormat(toDay, 'dd DD MMM');
      case _constants.constDateType.day:
        return getDateFormat(toDay, 'dd DD MMM');
      case _constants.constDateType.week:
        return "".concat(getDateFormat(fromDay, 'dd DD MMM'), " - ").concat(getDateFormat(toDay, 'dd DD MMM'));
      case _constants.constDateType.month:
        {
          const isSame = fromDay.month() === toDay.month();
          if (isSame) return getDateFormat(toDay, 'MMM YYYY');
          // const isCurrent = isSameCurrentDateByDay(toDay);
          // return `${getDateFormat(fromDay, 'DD MMM')} - ${getDateFormat(isCurrent ? toDay : getTo14Day(toDay), 'DD MMM YYYY')}`;
          return "".concat(getDateFormat(fromDay, 'DD MMM'), " - ").concat(getDateFormat(toDay, 'DD MMM YYYY'));
        }
      case _constants.constDateType.year:
        return "".concat(fromDay.year() !== toDay.year() ? "".concat(getDateFormat(fromDay, 'YYYY'), " - ") : '').concat(getDateFormat(toDay, 'YYYY'));
      case _constants.constDateType.max:
        return "".concat(getDateFormat(fromDay, 'YYYY'), " - ").concat(getDateFormat(toDay, 'YYYY'), "}");
      default:
        return getDateFormat();
    }
  }, [fromDay, openTo, toDay, momentLocale]);
  (0, _react.useEffect)(() => {
    setDisabledNext(Boolean(isSameCurrentDateByDay(toDay)));
    if (getFrom7Day(toDay).isAfter(reactMoment(minDate)) && reactMoment(fromDay).isoWeekday() !== 1) {
      setDisabledPrev(false);
      return;
    }
    if (openTo === _constants.constDateType.year && getFromYear(toDay).isBefore(reactMoment(minDate)) || openTo === _constants.constDateType.month && getFromMonth(toDay).isBefore(reactMoment(minDate))) {
      setDisabledPrev(true);
    }
  }, [toDay, openTo, minDate, fromDay, reactMoment]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    sx: {
      color: _constants.colors['main-color-cl-01']
    },
    disabled: disabledPrev,
    onClick: prevDate
  }, /*#__PURE__*/_react.default.createElement(_ArrowBackIosRounded.default, null)), /*#__PURE__*/_react.default.createElement(_material.Button, _extends({
    ref: inputRef,
    variant: "text"
  }, inputProps, {
    onClick: () => {
      var _InputProps$endAdornm;
      const {
        onClick: openCalendar
      } = (InputProps === null || InputProps === void 0 || (_InputProps$endAdornm = InputProps.endAdornment) === null || _InputProps$endAdornm === void 0 || (_InputProps$endAdornm = _InputProps$endAdornm.props) === null || _InputProps$endAdornm === void 0 || (_InputProps$endAdornm = _InputProps$endAdornm.children) === null || _InputProps$endAdornm === void 0 ? void 0 : _InputProps$endAdornm.props) || {};
      openCalendar === null || openCalendar === void 0 || openCalendar(true);
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    sx: {
      fontSize: '18px',
      textTransform: 'capitalize',
      color: _constants.colors['main-color-cl-01']
    }
  }, getButtonDate)), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    sx: {
      color: _constants.colors['main-color-cl-01']
    },
    disabled: disabledNext,
    onClick: nextDate
  }, /*#__PURE__*/_react.default.createElement(_ArrowForwardIosRounded.default, null)));
});

/** @todo add types */
const FIX_ME_LATER = _propTypes.default.any;
RenderInput.propTypes = {
  inputProps: _propTypes.default.shape({
    [_propTypes.default.string]: FIX_ME_LATER
  }),
  InputProps: _propTypes.default.shape({
    [_propTypes.default.string]: FIX_ME_LATER,
    endAdornment: _propTypes.default.shape({
      props: _propTypes.default.shape({
        children: _propTypes.default.shape({
          props: _propTypes.default.shape({
            onClick: _propTypes.default.func
          })
        })
      })
    })
  }),
  setFromDay: _propTypes.default.func,
  setToDay: _propTypes.default.func,
  setDate: _propTypes.default.func,
  fromDay: _propTypes.default.shape({
    month: _propTypes.default.func,
    year: _propTypes.default.func,
    [_propTypes.default.string]: FIX_ME_LATER
  }),
  toDay: _propTypes.default.shape({
    month: _propTypes.default.func,
    year: _propTypes.default.func,
    [_propTypes.default.string]: FIX_ME_LATER
  }),
  minDate: _propTypes.default.shape({
    [_propTypes.default.string]: FIX_ME_LATER
  }),
  openTo: _propTypes.default.string
};